var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "room-chat-bot-modal-component flex flex-col border border-gray-300",
    },
    [
      _c(
        "div",
        { staticClass: "h-20 px-6 border-b flex justify-between items-center" },
        [
          _c("button", { staticClass: "w-6 h-6", on: { click: _vm.onClose } }, [
            _c("img", {
              attrs: { src: require("@/assets/images/arrowBack.svg") },
            }),
          ]),
          _c(
            "div",
            {
              staticClass: "font-bold leading-9",
              staticStyle: { "font-size": "28px", color: "#1D242A" },
            },
            [_vm._v(_vm._s(_vm.$t("chatBot.botName")))]
          ),
          _c("button", { staticClass: "w-6 h-6", on: { click: _vm.onClose } }, [
            _c("img", {
              attrs: { src: require("@/assets/images/x_gray.svg") },
            }),
          ]),
        ]
      ),
      _c("ChatBot"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }